import { MuiBottomNavigationAction } from './MuiBottomNavigationAction';
import { MuiButton } from './MuiButton';
import { MuiCssBaseline } from './MuiCssBaseline';

export const components = {
  MuiBottomNavigationAction,
  MuiButton,
  MuiCssBaseline,
};
